import { toast } from 'react-toastify'

import { EToastings } from '@App/types/common'
import { ERRORS_HANDLER } from '@Config/config'

type TToastingKinds = 'error' | 'success' | 'info' | 'warning'

const STANDART_MESSAGES = {
    [EToastings.ERROR]: 'Unhandled error',
    [EToastings.SUCCESS]: 'Unhandled success message',
    [EToastings.INFO]: 'Unhandled info text case',
    [EToastings.WARN]: 'Unhandled warning text case'
}

export const onToasting = ({ type, message }: { type: TToastingKinds; message?: string | { error: string } }) => {
    const toastConfig = {
        position: 'bottom-right' as const,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored' as const
    }

    let messageText: string

    if (typeof message === 'string') {
        messageText = message
    } else if (message && typeof message === 'object' && 'error' in message) {
        messageText = message.error
    } else {
        messageText = STANDART_MESSAGES[type]
    }

    if (!messageText || messageText.trim().length === 0) {
        messageText = STANDART_MESSAGES[type]
    }

    toast[type](messageText, toastConfig)
}

export const onHandleResponseNotification = (status: number, message?: string | { error: string }) => {
    if (status === 401) return

    let messageText: string | undefined

    if (typeof message === 'string') {
        try {
            const parsed = JSON.parse(message)
            if (parsed && typeof parsed === 'object' && 'error' in parsed) {
                messageText = parsed.error
            } else {
                messageText = message
            }
        } catch {
            messageText = message
        }
    } else if (message && typeof message === 'object' && 'error' in message) {
        messageText = message.error
    } else {
        messageText = ERRORS_HANDLER[status || 500]
    }

    onToasting({
        type: EToastings[[200, 201, 204].includes(status) ? 'SUCCESS' : 'ERROR'],
        message: messageText && messageText.length > 0 ? messageText : ERRORS_HANDLER[status || 500]
    })
}

// ERRORS_HANDLER[error?.response?.status || 500]
